import axios from 'axios';

import { applyCompanyOverride } from '@/core/api/companyOverride';

import {
  requestInterceptor,
  requestErrorInterceptor,
} from '../interceptors/requestInterceptors';
import {
  responseInterceptor,
  responseErrorInterceptor,
} from '../interceptors/responseInterceptors';

const baseURL = import.meta.env.VITE_BASE_URL;

const ApiAxiosInstance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const apiAxiosInstanceWithoutAuth = axios.create({
  baseURL,
});

ApiAxiosInstance.interceptors.request.use(
  async (config) => applyCompanyOverride(await requestInterceptor(config)),
  requestErrorInterceptor
);

apiAxiosInstanceWithoutAuth.interceptors.request.use((config) => applyCompanyOverride(config));

ApiAxiosInstance.interceptors.response.use(
  responseInterceptor,
  responseErrorInterceptor
);


export { ApiAxiosInstance, apiAxiosInstanceWithoutAuth };
